<template>
    <div class="title_body">
                  <span class="text_title text-h6">{{ title }}</span>
                  <span class="btn_close"><v-btn icon dark @click="$emit('close')" ><v-icon dark > mdi-close </v-icon></v-btn> </span>
             </div>
</template>
<script>
export default {
    props: {
        title: String,
    },
}
</script>



<style scoped>
.title_body{
  background:#1976D2;
  width:100%;
  height:45px;
  box-sizing:border-box;
  padding:5px;
  margin-bottom:20px
}

</style>
